import { createAction } from '../../../store.model';
import { Draft } from '../../core';
import { ActionType } from '../form.action';
import { EvalFormValue } from '../model/eval-form-value.model';

export interface Save {
    formValue: EvalFormValue;
    publish?: boolean;
    /** required to get manager name from manager table for current user */
    timeZoneOffset?: number;
}

export const save = createAction<ActionType, Save>(ActionType.EVAL_FORM__SAVE);

export interface SaveResult extends Save {
    draft?: Draft;
}

export const saveResult = createAction<ActionType, SaveResult>(
    ActionType.EVAL_FORM__SAVE_RESULT,
);
